import { render, staticRenderFns } from "./web-mobile.vue?vue&type=template&id=96ca271e&scoped=true"
import script from "./web-mobile.vue?vue&type=script&lang=js"
export * from "./web-mobile.vue?vue&type=script&lang=js"
import style0 from "./web-mobile.vue?vue&type=style&index=0&id=96ca271e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ca271e",
  null
  
)

export default component.exports